import script from "./FunctionBox.vue?vue&type=script&setup=true&lang=ts"
export * from "./FunctionBox.vue?vue&type=script&setup=true&lang=ts"

import "./FunctionBox.vue?vue&type=style&index=0&id=25925d83&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-25925d83"]])

export default __exports__